import React from 'react'
import {
  TopBar,
  useGetContractByIdQuery,
  useGetPayloadSchemaByIdQuery
} from 'prove-common'
import { useParams } from 'react-router'
import { AppLogo } from '../app-logo/AppLogo'

export const SchemaScreenTopBar: React.FC = () => {
  const { contractId, payloadSchemaId } = useParams()
  const { data: contract } = useGetContractByIdQuery(Number(contractId))
  const { data: payloadSchema } = useGetPayloadSchemaByIdQuery(
    Number(payloadSchemaId)
  )
  return (
    <TopBar
      logo={<AppLogo />}
      breadcrumbItems={[
        {
          label: 'Kontrakter',
          to: '/contracts'
        },
        {
          label: contract?.title,
          to: `/contracts/${contractId}?tab=1`
        },
        {
          label: payloadSchema?.name
        }
      ]}
      showNotificationBell={true}
    />
  )
}
